import { fun_PostAction, fun_GetAction, fun_UploadImg, fun_Download } from "@/api/index";
// 引入转译方法
import { fun_DownloadFile } from "@/utils/validate";
// 默认导出
export default {
  // 数据存储对象
  data: () => {
    return {
      // 弹窗
      dialogVisible:false,
      // 列表loading状态
      loading: false,
      // 表头按钮组
      btnList: [
        {
          name: "添加",
          type: "success",
          icon: "document-add"
        },
        {
          name: "修改",
          type: "primary",
          icon: "edit"
        },
        {
          name: "删除",
          type: "danger",
          icon: "delete"
        },
        {
          name: "导入",
          type: "success",
          icon: "document-checked"
        },
      ],
      // 分页
      reqPageData: {
        current: 1, // 页码
        size: 10 // 每页条数
      },
      total: 0, // 总条数
      // 查询表单字段
      form: {
        transactionCode: null, // 交易目录编号
        transactionName: null, // 交易目录名称
      },
      // 查询表单
      formSearchList: [
        {
          type: "input",
          label: "交易目录名称：",
          value: "transactionName",
          placeholder: "请输入",
          clearable: true
        },
        {
          type: "input",
          label: "交易目录编号：",
          value: "transactionCode",
          placeholder: "请输入",
          clearable: true
        },
      ],
      // 表格基础数据
      tableColumns: [
        {
          label: "交易目录名称",
          prop: "transactionName",
          isShow: true,
        },
        {
          label: "交易目录编号",
          prop: "transactionCode",
        },
        {
          label: "上级目录编号",
          prop: "superTransactionCode",
        },
        {
          label: "是否已关联部门",
          slotName: "isRelated",
        },
        {
          label: "是否废弃",
          slotName: "disusedName",
        },
        {
          label: "操作",
          slotName: "operation",
        }
      ],
      // 表格数据
      tableData: [],
      multipleSelection: [], // 勾选数组
      pictureFiles: [], // 文件
      fileUrl: null// 交易目录模板的文件路径
    };
  },
  // 注册组件
  components: {
  },
  // 模板编译完成
  mounted() {
    // 查询一览数据
    this.fun_GetList();
    // 获取模板下载地址
    this.fun_FileRegulardownload();
  },
  // 自定义方法
  methods: {
    /**
     * 获取一览表格数据
     * @author 付翔
     */
    async fun_GetList() {
      try {
        // 打开loading
        this.loading = true;
        // 请求，获取结果集
        let res = await fun_PostAction("/transactionDirectory/list", {
          ...this.form,
          ...this.reqPageData
        });
        // 解构res.data
        const { result, data, msg } = res.data;
        // 判断请求是否成功
        if (result) {
          // 解构data
          const { total, records } = data;
          // 回显table
          this.tableData = records;
          // 获取分页总条数
          this.total = total;
        } else {
          // 提示请求失败消息
          this.$message.error(msg);
        }
        // 关闭loading
        this.loading = false;
      } catch {
        // 关闭loading
        this.loading = false;
      }
    },
    /**
     * 查询
     * @author 滕威
     */
    fun_Search() {
      // 重置分页
      this.reqPageData = {
        current: 1, // 页码
        size: 10 // 每页条数
      };
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 重置
     * @author 滕威
     */
    fun_Reset() {
      // 清除查询表单
      this.$refs.list.$refs.formItem.map(e => {
        e.resetField();
      });
      // 重置分页
      this.reqPageData = {
        current: 1, // 页码
        size: 10 // 每页条数
      };
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 改变每页条数执行的函数
     * @params e 每页条数
     * @author 滕威
     */
    fun_LimitChange(e) {
      // 获取每页显示条数
      this.reqPageData.size = e;
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 改变页码执行的函数
     * @params e 页码数
     * @author 滕威
     */
    fun_PageChange(e) {
      // 获取当前页码
      this.reqPageData.current = e;
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 表头按钮事件
     * @params e 按钮name
     * @author 付翔
     */
    fun_click(e) {
      switch (e) {
        case "添加":
          this.fun_Add();
          break;
        case "修改":
          this.fun_Edit();
          break;
        case "删除":
          this.fun_Del();
          break;
        case "导入":
          this.fun_OpenImport();
          break;
        default:
      }
    },
    /**
     * 勾选事件
     * @params e 选中的数据
     */
    fun_HandleSelectionChange(e) {
      // 将勾选的value值赋给multipleSelection数组
      this.multipleSelection = e;
    },
    /**
     * 下拉框值改变事件
     * @author shuhua
     */
    fun_GetSelectVal(e, i) {
      // 赋值
      this.form[i] = e;
    },
    /**
     * 查看详情
     * @params e 点击的行数据
     * @author 付翔
     */
    fun_Details(e) {
      // 子传父
      // this.$emit("fun_Details", "transactionDirectoryDetails", {id:e.val.id, type:"details"});
      // 跳转详情页面
      this.$router.push({path: "/transactionDirectoryDetail", query: {id:e.val.id,  type: "details" }});
    },
    /**
     * 点击新增按钮
     */
    fun_Add() {
      // 子传父
      // this.$emit("fun_Details", "transactionDirectoryDetails", {type:"insert"});
      this.$router.push({path: "/transactionDirectoryDetail", query: { type: "insert" }});
    },
    /**
     * 点击修改按钮
     */
    fun_Edit() {
      // 判断是否勾选
      if (this.multipleSelection && this.multipleSelection.length > 0){
        // 如果勾选超过1条
        if(this.multipleSelection.length > 1){
          // 提示，并清除选中数据
          this.$alert("只能选择一条数据！", "warning").then(() => {
            // 清除选中数据
            this.$refs.list.$refs.multipleTable.clearSelection();
          });
        }else{
          // 子传父
          // this.$emit("fun_Details", "transactionDirectoryDetails", {id:this.multipleSelection[0].id, type:"update"});
          this.$router.push({path: "/transactionDirectoryDetail", query: {id:this.multipleSelection[0].id, type: "update" }});
        }
      }
    },
    /**
     * 删除
     */
    fun_Del(){
      // 判断是否勾选
      if (this.multipleSelection && this.multipleSelection.length > 0) {
        // 主键集合
        let keys = [];
        // 遍历勾选
        for(const index in this.multipleSelection ){
          // 赋值主键集合
          keys[index] = this.multipleSelection[index].id;
        }
        // 弹出询问confirm
        this.$confirm("是否确定删除选中数据？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
          // 请求，获取结果集
          fun_PostAction("/transactionDirectory/delete", {
            keys: keys
          }).then(res => {
            // 解构res.data
            const { msg } = res.data;
            // 操作成功
            this.$message.success(msg);
            // 获取一览表格数据
            this.fun_GetList();
          });
        });
      }
      // 如果未进行勾选
      else{
        // 提示，并清除选中数据
        this.$alert("最少选择一条数据！", "warning");
      }
    },
    /**
     * 打开导入弹框
     */
    fun_OpenImport(){
      // 打开弹窗
      this.dialogVisible = true;
    },
    /**
     * 文件上传
     */
    fun_FileDetail(file, fileList) {
      // 获取文件后缀名
      const suffix = file.name.substring(file.name.lastIndexOf(".") + 1).toLowerCase();
      // 这里限定上传文件文件类型必须为.xlsx或.xls，如果文件类型不符，提示错误信息
      if (suffix == 'xlsx' || suffix == 'xls'){
        // 如果上传文件大于1
        if (fileList.length > 1) {
          // 根据下标删除列表中的文件
          this.$refs[fileList].uploadFiles.splice(0, 1);
        }
        // 加入集合
        this.pictureFiles.push(file);
      }else{
        // 清空上传的文件
        this.$refs.fileUpload.clearFiles();
        // 提示错误消息
        this.$message.error("错误提示:上传文件应该为.xlsx 或 .xls格式，请重新选择文件后上传");
        // 返回
        return false;
      }
    },
    /**
     * 导入文件
     */
    fun_ExcelImport(){
      // 定义formData
      let formData = new FormData();
      // 如果上传附件不为空
      if (this.pictureFiles.length > 0) {
        // 设置文件
        formData.append("file", this.pictureFiles[0].raw);
      }else{
        // 提示错误消息
        this.$message.error("错误提示:请选择文件后上传");
        // 返回
        return false;
      }
      // 请求
      fun_UploadImg("/transactionDirectory/excelImport", formData).then(res => {
        // 解构res.data
        const { result, msg } = res.data;
        // 解析后台返回的结果集，判断是否成功
        if (result) {
          // 操作成功
          this.$message.success(msg);
          // 清空文件
          this.pictureFiles = [];
          // 刷新表单
          this.fun_GetList();
        } else {
          // 请求失败，弹出失败msg的消息提示
          this.$message.error(msg);
          // 刷新表单
          this.fun_GetList();
        }
        // 关闭loading
        this.loading = false;
      });
    },
    /**
     * 模板下载
     */
    fun_FileRegulardownload(){
      // 发起请求
      fun_GetAction("/clientFileInfo/getAutomaticallyUpdateFiles", {
        number: 2,
        appName: "交易目录模板"
      }).then(res => {
        // 解构res.data
        const { result, data, msg } = res.data;
        // 操作成功
        if (result) {
          // 图片压缩.zip的路径
          this.fileUrl = data;
        }else{
        }
      });
    },
    /**
     * 文件下载
     */
    fun_Download(e) {
      // 获取id
      fun_Download("/downloadLocal?filePath=" + e).then(res => {
        if (res) {
          // 获取头部
          let fileNames = res.headers["content-disposition"]; //获取到Content-Disposition;filename
          let regFileNames = fileNames.match(/=(.*)$/)[1];
          fun_DownloadFile(res, decodeURIComponent(regFileNames));
        }
      });
    },
    /**
     * 关联部门
     */
    fun_Relate(e){
      // 子传父
      this.$router.push({path: "/transactionDirectoryDetail", query: {id:e.id, type: "relate" }});
    }
  }
};
